var scope_0 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4ddfe9e9f74f279f6dbcc945f81b7f7d.js').default;
var scope_1 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/853e131f758ee4a9a4de79b04e6ee84d.js').default;
var scope_2 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b88725aa96abb87b16cdab524cf22ded.js').default;
var scope_3 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ea28c72321d6dfa9fe45637fb3a01f8d.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    